import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FeeDefinitionModel } from 'src/app/admin/admin-home/admin-fee-definition/fee-definition-model';

@Component({
  selector: 'app-fee-add-button',
  templateUrl: './fee-add-button.component.html',
  styleUrls: ['./fee-add-button.component.scss'],
  standalone: false
})
export class FeeAddButtonComponent {
  @Input({ required: true }) element!: FeeDefinitionModel;
  @Output() addFee = new EventEmitter<FeeDefinitionModel>();
}
